<template>
    <div class="fc-wrapper">
        <div class="fc">
            <burger-fc front="Burger 1"
                       back="Burger 4"
                       headerFront="Burger Friday"
                       headerBack="Burger Friday"
                       footerBack="click..."
                       footerFront="click..."
                       colorFront="Red"
                       colorTextFront="White"
                       colorBack="Blue"
                       v-bind:imgFront="'/images/' + burgers.burger1"
                       v-bind:imgBack="'/images/' + burgers.burger4"></burger-fc>
                       
        </div>
        <div class="fc">
            <burger-fc front="Burger 2"
                       back="Burger 5"
                       headerFront="Burger Friday"
                       headerBack="Burger Friday"
                       footerBack="click..."
                       footerFront="click..."
                       colorFront="Red"
                       colorTextFront="White"
                       colorBack="Blue"
                       v-bind:imgFront="'/images/' + burgers.burger2"
                       v-bind:imgBack="'/images/' + burgers.burger5">

            </burger-fc>
        </div>
        <div class="fc">
            <burger-fc front="Burger 3"
                       back="Burger 6"
                       headerFront="Burger Friday"
                       headerBack="Burger Friday"
                       footerBack="click..."
                       footerFront="click..."
                       colorFront="Red"
                       colorTextFront="White"
                       colorBack="Blue"
                       v-bind:imgFront="'/images/' + burgers.burger3"
                       v-bind:imgBack="'/images/' + burgers.burger6">

            </burger-fc>
        </div>
    </div>
</template>

<script>
    import flashcard from './flashcard'
    export default {
        name: 'Flashcards',
        props: {
            msg: String
        },
        components: {
            'burger-fc': flashcard
        },
        data: function () {
            return {
                burgers: {
                    burger1: 'burger1.jpg',
                    burger2: 'burger2.jpg',
                    burger3: 'burger3.jpg',
                    burger4: 'burger4.jpg',
                    burger5: 'burger5.jpg',
                    burger6: 'burger6.jpg'
                }
            }
        }
    };

</script>

<style scoped>
    .fc-wrapper {
        display: flex;
        justify-content: space-around;
    }

    .fc {
        width: 100%;
    }
</style>